import { combineReducers } from 'redux';

import appOnboardingModal from '@/components/AppOnboarding/redux/slice';
import membersOnlyWarningModal from '@/components/MembersOnlyWarningModal/redux/slice';
import contactus from '@/components/modals/ContactUs/reducer';
import installApp from '@/components/modals/InstallApp/reducer';
import pushNotification from '@/components/NotificationPermissionModal/reducer';
import productsPromptModalSlice from '@/components/products/ProductsPromptModal/redux/slice';
import terms from '@/components/TermsAndConditions/redux/slice';

export default combineReducers({
  [terms.name]: terms.reducer,
  contactus,
  installApp,
  pushNotification,
  [membersOnlyWarningModal.name]: membersOnlyWarningModal.reducer,
  [appOnboardingModal.name]: appOnboardingModal.reducer,
  [productsPromptModalSlice.name]: productsPromptModalSlice.reducer,
});
